// @ts-nocheck
import networkTS from '@/misc/apis/networkTS'
import {
  NylasAttendeeStatus,
  NylasCreateEventRequest,
  NylasUpdateEventRequest,
  NylasAttendeeStatus,
  NylasSetCalendarRequest,
  ScopesEnum
} from '@/types/api'

export default {
  toObject(stringDate) {
    if (!stringDate) {
      return null
    }

    const convDate = new Date(stringDate)
    return convDate instanceof Date && isFinite(convDate.getTime())
? {
      day: convDate.getDate(),
      month: convDate.getMonth() + 1,
      year: convDate.getFullYear()
    }
: null
  },
  getEventStat(ownerId, userIds) {
    const now = new Date()
    const nextThreeMonth = (new Date()).setDate(now.getDate() + 90)
    const body = {
      ownerId: ownerId,
      userIds: userIds,
      sortStart: 'ASC',
      endDate: this.toObject(nextThreeMonth),
      startDate: this.toObject(now)
    }
    return networkTS.nylasServiceListEvents(body)
      .then(response => {
      return response.data
    })
  },
  getListEvents(ownerId = '', referenceIds = [], userIds = [], startDate = null, endDate = null, sortStart = 'ASC', attendeeEmails = [], requestParams = {}) {
    const body = {
      attendeeEmails: attendeeEmails,
      endDate: endDate,
      ownerId: ownerId,
      referenceIds: referenceIds,
      sortStart: sortStart,
      startDate: startDate,
      userIds: userIds
    }
    return networkTS.nylasServiceListEvents(body, requestParams)
      .then(response => {
        return response.data
      })
  },
  startAuthNylas(scopes: ScopesEnum[], initialUrl: string) {
    return networkTS.nylasAuthServiceStartAuth({ initialUrl: initialUrl, scopes: scopes })
      .then(response => {
        return response.data
      })
  },
  listAvailableCalendars(userId: string) {
    return networkTS.nylasServiceListAvailableCalendars(userId)
      .then(response => {
        return response.data
      })
  },
  listCalendarByUserId(userId: string) {
    return networkTS.nylasServiceListCalendarByUserId(userId)
      .then(response => {
        return response.data
      })
  },
  listCalendarsByUserIds(userIds: string[]) {
    return networkTS.nylasServiceListCalendarsByUserIds({
      ids: userIds
    })
      .then(response => {
        return response.data
      })
  },
  setCalendar(body: NylasSetCalendarRequest) {
    return networkTS.nylasServiceSetCalendar(body)
      .then(response => {
        return response.data
      })
  },
  createEvent(event, ownerId, participants, calendarId) {
    const body = {
      calendarId: calendarId,
      title: event.title,
      description: event.description,
      location: event.location,
      ownerId: ownerId,
      referenceIds: event.referenceIds,
      startTime: event.startTime,
      endTime: event.endTime,
      startDate: event.startDate,
      endDate: event.endDate,
      attendees: participants,
      visibility: event.private ? 'EVENT_VISIBILITY_PRIVATE' : 'EVENT_VISIBILITY_PUBLIC',
      userId: event.userId,
      mediaIds: event.mediaIds,
      frequency: event.frequency || 'EVENT_FREQUENCY_UNDEFINED',
      occurrenceCount: event.occurrenceCount ? parseInt(event.occurrenceCount) : 0,
      recurrenceEndDate: event.recurrenceEndDate,
      recurrenceStartDate: event.recurrenceStartDate,
      notifyParticipants: event.notifyParticipants,
      reminders: event.reminders || []
    } as NylasCreateEventRequest
    return networkTS.nylasServiceCreateEvent(body)
      .then(response => {
        return response.data
      })
  },
  updateEvent(event, ownerId, participants, referenceId = [], masterEventId = '') {
    const eventData = {
      id: masterEventId !== '' ? masterEventId : event.id,
      title: event.title,
      description: event.description,
      location: event.location,
      referenceIds: referenceId,
      startTime: event.startTime,
      endTime: event.endTime,
      startDate: event.startDate,
      endDate: event.endDate,
      attendees: participants,
      visibility: event.visibility ? event.visibility : event.private ? 'EVENT_VISIBILITY_PRIVATE' : 'EVENT_VISIBILITY_PUBLIC',
      userId: event.userId,
      mediaIds: event.mediaIds,
      reminders: event.reminders || [],
      notifyParticipants: event.notifyParticipants,
      frequency: event.frequency || 'EVENT_FREQUENCY_UNDEFINED',
      occurrenceCount: event.occurrenceCount ? parseInt(event.occurrenceCount) : 0,
      recurrenceEndDate: event.recurrenceEndDate || null,
      recurrenceStartDate: event.recurrenceStartDate || null
    } as NylasUpdateEventRequest

    return networkTS.nylasServiceUpdateEvent(eventData)
      .then(response => {
        return response.data
      })
  },
  deleteEvent(id, userId) {
    return networkTS.nylasServiceDeleteEvent({ id: id, userId: userId })
      .then(response => {
      return response.data
    })
  },
  setExternalAttendeesStatus(status, token) {
    const body = {
      status: status,
      token: token
    }
    return networkTS.calendarServiceSetExternalAttendeeStatus(body).then(response => {
      return response.data
    })
  },
  getEventByIcs(mediaId) {
    return networkTS.nylasServiceGetEventByIcs(mediaId)
      .then(response => {
        return response.data
      })
  },
  getUserConfig() {
    return networkTS.nylasAuthServiceGetMyConfig()
      .then(response => {
        return response.data
      })
  },
  unlinkAccount() {
    return networkTS.nylasAuthServiceUnlink()
      .then(response => {
        return response.data
      })
  },
  updateStatusAttendee(calendarId: string, eventId: string, userId: string, status: NylasAttendeeStatus) {
    return networkTS.nylasServiceSendRsvp({ calendarId: calendarId, eventId: eventId, userId: userId, status: status })
      .then(response => {
        return response.data
      })
  }
}
